import { DisposableEventAggregator } from '@repo/rpc/disposable-event-aggregator';
import type { MessageData } from '@repo/rpc/rpc';
import type { IDisposable } from '@repo/types/shared/disposable';
import type { ClientRpc } from './rpc-types';

export class ActionClient implements IDisposable {
    private events = new DisposableEventAggregator();
    private rpc: ClientRpc;
    private readonly handlerActions: string[] = [];

    public constructor(rpc: ClientRpc) {
        this.rpc = rpc;

        this.handle(
            'teleport_countdown_result',
            async (result: { actionId: string; outcome: 'completed' | 'cancelled' }) =>
                this.events.publish('teleport_countdown_result', result),
        );
    }

    private handle(action: string, handler: (data: never) => MessageData | Promise<MessageData>): void {
        this.handlerActions.push(action);
        this.rpc.setHandler(action, handler);
    }

    public async requestTeleportCountdown(config: {
        actionId: string;
        label: string;
        duration: number;
    }): Promise<void> {
        await this.rpc.execute('teleport_countdown_start', config);
    }

    public onTeleportCountdownResult(
        handler: (result: { actionId: string; outcome: 'completed' | 'cancelled' }) => void,
    ): IDisposable {
        return this.events.subscribe('teleport_countdown_result', handler);
    }

    public dispose(): void {
        for (const action of this.handlerActions) this.rpc.removeHandler(action);
        this.events.dispose();
    }
}
